<template>
  <v-app 	:class="{'rtl-layout': $vuetify.locale.current === 'he' ? true:false,'rtl':$vuetify.locale.current === 'he' ? true:false}">
    <router-view></router-view>
  </v-app>
</template>

<script>
import "./assets/scss/_style.scss";

export default {
  name: 'App',
  data() {
    return {
      rtlLayout:false
    }
  },
  components: {},
  mounted() {}
}
</script>

<style>
.rtl {
  direction: rtl !important
}
</style>
